import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import { useContent } from "@/lib/content-context";

const FALLBACK = {
    eyebrow: "Privacy Policy",
    title: "Your data. Our duty.",
    updated: "Last updated: February 2026",
    sections: [],
};

export default function Privacy() {
    const { content } = useContent();
    const p = { ...FALLBACK, ...(content?.privacy || {}) };
    const sections = p.sections || [];

    return (
        <div className="bg-cream-light pt-28" data-testid="privacy-page">
            <SEO title="Privacy Policy" description="How Cafe Hideout collects and uses your information." path="/privacy" />
            <section className="px-6 md:px-12 py-16 md:py-24">
                <div className="max-w-[860px] mx-auto">
                    <Reveal>
                        <div className="tracked text-coffee/50 text-[10px] mb-6">{p.eyebrow}</div>
                        <h1 className="font-editorial font-bold text-coffee leading-[0.98]" style={{ fontSize: "clamp(2.2rem, 5vw, 4.4rem)" }}>
                            {p.title}
                        </h1>
                        <p className="font-body text-coffee/70 mt-6">{p.updated}</p>
                    </Reveal>

                    <div className="mt-14 space-y-12">
                        {sections.map((s, i) => (
                            <Reveal key={i} delay={i * 0.04}>
                                <div className="border-t border-coffee/15 pt-8">
                                    <div className="font-mono tracked text-gold text-[10px] mb-2">{String(i + 1).padStart(2, "0")}</div>
                                    <h2 className="font-editorial font-medium text-coffee text-2xl md:text-3xl mb-3">{s.h}</h2>
                                    <p className="font-body font-light text-coffee/80 text-base md:text-[17px] leading-[1.85] whitespace-pre-wrap">{s.body}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
